import { createContext, useContext, useState } from 'react';

const TransactionReturnContext = createContext();

export const useTransactionReturnContext = () =>
  useContext(TransactionReturnContext);

export const TransactionReturnContextProvider = ({ children }) => {
  const [menuItems, setMenuItems] = useState([]);
  const [totalPcsDiamond, setTotalPcsDiamond] = useState(0);
  const [totalPcsStone, setTotalPcsStone] = useState(0);
  const [totalDiamondWeight, setTotalDiamondWeight] = useState(0);
  const [totalStoneWeight, setTotalStoneWeight] = useState(0);
  const [totalPrate, setTotalPrate] = useState(0);
  const [totalDiamondAmount, setTotalDiamondAmount] = useState(0);
  const [totalStoneAmount, setTotalStoneAmount] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [path, setPath] = useState('');
  const [metalReceiveDetails, setMetalReceiveDetails] = useState([]);
  const [metalReceiveSummary, setMetalReceiveSummary] = useState({});
  const [storeBillNumberDetails, setStoreBillNumberDetails] = useState([]);
  const [purchaseReturnHeader, setPurchaseReturnHeader] = useState({
    ledger: '',
    billNo: '',
    entryNo: '',
    returnDate: null,
    ledgerName: '',
    itemName: '',
    itemCode: '',
    remarks: '',
  });

  const [tableData, setTableData] = useState([
    {
      key: '1',
      typeId: '',
      rateOn: '',
      pcs: 0,
      unit: '',
      weight: '',
      purchaseRate: 0,
      salesRate: 0,
      hc: '',
      color: '',
      clarity: '',
      cut: '',
      amount: 0,
      remark: '',
      isName: '',
      itemTypeId: '',
      itemTypeName: '',
      disabledUnit: false,
    },
  ]);
  const updateRowData = (index, updatedRow) => {
    if (updatedRow?.delete) {
      const newData = [...storeBillNumberDetails];
      newData.splice();
    }

    setStoreBillNumberDetails((prevStoreBillNumberDetails) => {
      const newStoreBillNumberDetails = [...prevStoreBillNumberDetails];
      newStoreBillNumberDetails[index] = updatedRow;
      return newStoreBillNumberDetails;
    });
  };

  return (
    <TransactionReturnContext.Provider
      value={{
        menuItems,
        setMenuItems,
        path,
        setPath,
        updateRowData,
        setTotalDiamondAmount,
        setTotalDiamondWeight,
        setTotalPcsDiamond,
        setTotalPcsStone,
        setTotalStoneWeight,
        setTotalPrate,
        setTotalStoneAmount,
        totalPcsDiamond,
        totalPcsStone,
        totalDiamondWeight,
        totalStoneWeight,
        totalPrate,
        totalDiamondAmount,
        totalStoneAmount,
        tableData,
        setTableData,
        rowData,
        setRowData,
        storeBillNumberDetails,
        setStoreBillNumberDetails,
        purchaseReturnHeader,
        setPurchaseReturnHeader,
        metalReceiveDetails,
        setMetalReceiveDetails,
        metalReceiveSummary,
        setMetalReceiveSummary,
      }}
    >
      {children}
    </TransactionReturnContext.Provider>
  );
};
